import { render, staticRenderFns } from "./KoProposalModal.vue?vue&type=template&id=6db93c64&"
import script from "./KoProposalModal.vue?vue&type=script&lang=js&"
export * from "./KoProposalModal.vue?vue&type=script&lang=js&"
import style0 from "./KoProposalModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports